module.exports = __webpack_public_path__ + "media/images/plans/photo_location/main-a508ddac2bd2133b37e67d247bcd6e25.png";